const objectSubcription = {}

const constantObjectSubcriptionType = {
  submitQuizAnswerType: 'live-proxy-submit-quiz',
}

// Hàm tạo và đăng ký promise cho một id
const subscribe = (objectSubcriptionKey) => {
  // eslint-disable-next-line promise/avoid-new
  return new Promise((resolve, reject) => {
    // Đặt Promise vào objectSub với key là objectSubcriptionType + slideId
    objectSubcription[objectSubcriptionKey] = { resolve, reject }
  })
}

export default {
  subscribe,
  constantObjectSubcriptionType,
  objectSubcription,
}
